import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Icon from '../../../core/Icon';
import { withStyles, createStyles } from '@material-ui/core/styles';
var styles = createStyles({
  root: {
    float: 'right',
    position: 'relative',
    right: 10,
    top: 3,
    display: 'inline-block'
  },
  iconCommon: {
    fontSize: 14
  },
  iconWrapper: {
    width: 32,
    height: 32
  }
});
/**
 * @extends {React.Component<import('./types').DataGridViewModeProps & import('@material-ui/core').WithStyles<typeof styles>> }
 */

var GridViewMode =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridViewMode, _React$Component);

  function GridViewMode() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, GridViewMode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(GridViewMode)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onSelectDetail = function (e) {
      return _this.props.onChange(e, 'detail');
    };

    _this.onSelectThumbnail = function (e) {
      return _this.props.onChange(e, 'thumbnail');
    };

    return _this;
  }

  _createClass(GridViewMode, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mode = _this$props.mode,
          classes = _this$props.classes;
      return React.createElement("div", {
        className: classes.root
      }, React.createElement("span", {
        className: classes.iconWrapper
      }, React.createElement(Icon, {
        hoverable: true,
        label: mode === 'detail' ? 'Switch to thumbnail view' : 'Thumbnail view (current)',
        style: {
          opacity: mode === 'thumbnail' ? 1 : 0.3
        },
        onClick: this.onSelectThumbnail,
        type: "thumbnail",
        color: "inherit",
        className: classes.iconCommon
      })), React.createElement("span", {
        className: classes.iconWrapper
      }, React.createElement(Icon, {
        hoverable: true,
        label: mode === 'thumbnail' ? 'Switch to detail view' : 'Detail view (current)',
        style: {
          opacity: mode === 'detail' ? 1 : 0.3
        },
        onClick: this.onSelectDetail,
        type: "detail",
        color: "inherit",
        className: classes.iconCommon
      })));
    }
  }]);

  return GridViewMode;
}(React.Component);

GridViewMode.defaultProps = {
  mode: 'detail'
};
export default withStyles(styles, {
  name: 'ECGridViewMode'
})(GridViewMode);